import { ChangeDetectorRef, Component, ElementRef, EventEmitter, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatColumnDef, MatTable, MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { IContract } from 'src/app/models/Contract';
import { ContractsService } from 'src/app/services/contracts.service';
import { AlignType, ButtonType, ColumnType, FilterOperator, FilterOptions, FilterOptionsType, ISAPI, ISColumn, ISFilterAPI, ISMultiSelectDatasource, ISMultiSelectOption, ISMultiSelectStyleObject, ISPagination, ISSelectableRowsOptions, ISSelectOption, ISTableDatasource, MVFilter, MVListingConfigs, MVOrdering, SortDirection } from 'is-lib';
import { FormControl, FormGroup } from '@angular/forms';
import { BehaviorSubject, concatMap, debounce, debounceTime, delay, distinctUntilChanged, forkJoin, from, mergeMap, Observable, Subject, takeUntil } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UsersService } from 'src/app/services/users.service';
import { AddressesService } from 'src/app/services/addresses.service';
import { District } from 'src/app/models/District';
import { ServerResponse } from 'src/app/models/ServerResponse';
import { Status } from 'src/app/models/Status';
// Aliased: models/Contract also exports an IContract (the contracts list item)
import { IContract as IContractForm } from 'src/app/models/ContractResponse';
import { Router, RouterModule } from '@angular/router';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { MatDialog } from '@angular/material/dialog';
import { ContractAccessComponent } from '../contract-access/contract-access.component';
import { IContractElectricitySupply } from 'src/app/models/ElectricitySupply';
import { IContractNaturalGasSupply } from 'src/app/models/NaturalGasSupply';
import { IContractSelfConsumptionSupply } from 'src/app/models/SelfConsumptionSupply';
import * as _ from 'lodash';
import { SelectionModel } from '@angular/cdk/collections';
import { TicketFormComponent } from '../../supportRequests/form/ticket-form.component';
import { TranslateService } from '@ngx-translate/core';
import { LoaderConfig } from 'src/app/services/generic.service';

@Component({
  selector: 'app-contracts-list',
  templateUrl: './contracts-list.component.html',
  styleUrls: ['./contracts-list.component.scss'],
})
export class ContractsComponent implements OnInit, OnDestroy {
    // Ends the translation stream subscription, which never completes on its own
    private readonly _destroy$ = new Subject<void>();

    DEFAULT_STATUS_FILTERS: Array<string> = ['Active', 'Accepted', 'InActivation', 'Inserted'];
    statusSelectOptions: ISMultiSelectOption[] = [];

    displayedColumnsContracts: string[] = ['SELECTED', 'CONTRACT_NUMBER', 'STATUS', 'PRODUCT', 'ELECTRICITY_SUPPLY_POINTS', 'NATURAL_GAS_SUPPLY_POINTS', 'AUTOCONSUMPTION_SUPPLY_POINTS', 'ACTIONS'];
    displayedColumnsConsumptionPoints: string[] = ['SELECTED', 'EQUIPMENT_CODE', 'CONSUMPTION_POINT', 'STATUS', 'PRODUCT', 'CONTRACT_NUMBER', 'ACTIONS'];
    
    contractStatesLabels = [
        {id: 'Pending', color: 'warning' },
        {id: 'Canceled', color: 'danger' },
        {id: 'Active', color: 'success' },
        {id: 'Accepted', color: 'success' },
        {id: 'InActivation', color: 'info' },
        {id: 'Inserted', color: 'info' },
        {id: 'PendingSupplier', color: 'warning' },
        {id: 'Terminated', color: 'danger' }
    ]

    initialized: boolean = false;

    totalRecords = {
        contracts: 0
    };

    paginationPageSizes: number[] = [5, 10, 25, 100];
    
    contracts: IContract[] = [];

    contractsListingConfig: MVListingConfigs;
    contractSuppliesListingConfig: MVListingConfigs;

    manuallySelectedContractIds: string[] = []
    contractSelectionModel: SelectionModel<IContract> = new SelectionModel<IContract>(true, undefined, true, (contract1, contract2) => contract1.guidId == contract2.guidId)
    contractExpansionModel: SelectionModel<IContract> = new SelectionModel<IContract>(true, undefined, true, (contract1, contract2) => contract1.guidId == contract2.guidId)
    contractSupplySelectionModel: SelectionModel<IContractElectricitySupply|IContractNaturalGasSupply|IContractSelfConsumptionSupply> = new SelectionModel<IContractElectricitySupply|IContractNaturalGasSupply|IContractSelfConsumptionSupply>(true, undefined, true, (supply1, supply2) => supply1.guidId == supply2.guidId)

    toggle = false;
    toggle2 = false;

    // productSelect: any;
    productSelect$!: BehaviorSubject<ISMultiSelectDatasource>;

    statusSelect: Status[] = [];
    districtSelect: District[] = [];
    additionalContractInfo: IContractForm[] = [];
    selectAll: boolean = false;

    filterTranslationObject: {[key: string]: string[]} = {
        'number': ['MVContractNumber', ''],
        'status': ['InvariantCultureDescription', 'FkContractStatusNavigation'],
        'supplyPoint': ['Name', 'FkClientNavigation;FkAddressNavigation;FkPostalCodeNavigation;FkLocalityNavigation;FkCountyNavigation;FkDistrictNavigation'],
        'equipmentCode': ['CPE1', 'FkCPENavigation'],
        'product': ['Name', 'FkSupplierProduct']
    }

    productSelectDatasource$: BehaviorSubject<ISMultiSelectDatasource> = new BehaviorSubject<ISMultiSelectDatasource>({
        apiUrl: `${environment.apiUrl}Suppliers/${this._userService.userCountryCode}/Products/Get`,
        parentColumns: [
            new ISColumn('id', 'ID', new FilterOptions(null, FilterOptionsType.text), ColumnType.text ),
            new ISColumn('name', 'NAME', new FilterOptions(null, FilterOptionsType.text, FilterOperator.contains, undefined, 'name'), ColumnType.text ),
            new ISColumn('products', 'PRODUCTS', new FilterOptions(null, FilterOptionsType.text), ColumnType.text, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, true)
        ],
        columns: [
            new ISColumn('id', 'ID', new FilterOptions(null, FilterOptionsType.text), ColumnType.text ),
            new ISColumn('name', 'NAME', new FilterOptions(null, FilterOptionsType.text), ColumnType.text ),
        ],
        pagination: new ISPagination(99, 0),
        totalItems: 0
    })

    contractsTableFilters: any[] = [];
    statusFilters: any[] = [];

    proposalStatesLabels: Status[] = [];
    filterOverlayIsOpen: boolean = false
    connectedOverlayPositions: ConnectedPosition = {
        originX: 'start',
        originY: 'bottom',
        overlayX: 'start',
        overlayY: 'top',
        offsetY: 10
    }

    contractsForm = new FormGroup({
        contractNumber: new FormControl<string>(''),
        product: new FormControl<string[] | null>(null),
        status: new FormControl<string[] | null>(this.DEFAULT_STATUS_FILTERS),
        district: new FormControl<string>(''),
        equipmentCode: new FormControl<string>(''),
        location: new FormControl<string>(''),
        page: new FormControl<number>(1),
        pageSize: new FormControl<number>(10)
    });

    constructor(private _contractsService: ContractsService, private _userService: UsersService, private _addressService: AddressesService, private _cdRef: ChangeDetectorRef, private _router: Router, private _dialog: MatDialog, private _translateService: TranslateService) {
        this.contractsListingConfig = new MVListingConfigs(
            [
                // new MVFilter('GuidId', this.DEFAULT_STATUS_FILTERS.join('|'), FilterOptionsType.text, FilterOperator.in, 'FkContractStatusNavigation'),
                // new MVFilter('MVContractNumber', '', FilterOptionsType.text, FilterOperator.contains),
                // new MVFilter('Id', '', FilterOptionsType.number,FilterOperator.in, 'FkClientNavigation;FkAddressNavigation;FkPostalCodeNavigation;FkLocalityNavigation;FkCountyNavigation;FkDistrictNavigation'),
                // new MVFilter('CPE1', '', FilterOptionsType.text,FilterOperator.contains,'FkCPENavigation'),
            ],
            null,
            new ISPagination(9999, 0)
        );

        this.contractSuppliesListingConfig = new MVListingConfigs(
            [
                // new MVFilter('selected', '', ColumnType.boolean),
                // new MVFilter('mvContractNumber', '', ColumnType.number, FilterOperator.contains),
                // new MVFilter('status', '', ColumnType.select, FilterOperator.in),
                // new MVFilter('district', '', ColumnType.text, FilterOperator.in),
                // new MVFilter('equipment_code', '', ColumnType.text, FilterOperator.contains)
            ],
            null,
            new ISPagination(9999, 0)
        );

        this.statusSelectOptions = this.contractStatesLabels.map( (status) =>{
                let badgeClass = `badge badge-light-${status.color} text-${status.color} border border-${status.color}-subtle`;
                return new ISMultiSelectOption(status.id, 'CONTRACT_STATES.' + status.id, undefined, badgeClass);
            }
        );
    }

    ngOnDestroy(): void {
        this._destroy$.next();
        this._destroy$.complete();
    }

    ngOnInit(): void {
        this.filtersFormSubscriptions();
        // Also loads the contracts, once the filter selects are filled
        this.filtersSelectsCreation();
    }

    filtersFormSubscriptions() {
        this.contractSupplySelectionModel.changed.subscribe( change => {
            if (change.added.length > 0) {
                let contractIdsOfAdded = change.added.map( (cs) => cs.contractGuid );
                let contractsOfAdded = _.uniq( this.contracts.filter(contract => contractIdsOfAdded.includes(contract.guidId)) );
                
                contractsOfAdded.forEach( (c) => {
                    if (!this.isContractSelected(c)) {
                        this.contractSelectionModel.select(c);
                    }
                } )
            }

            if (change.removed.length > 0) {
                let contractIdsOfRemoved = change.removed.map( (cs) => cs.contractGuid );
                let contractsOfRemoved = _.uniq( this.contracts.filter(contract => contractIdsOfRemoved.includes(contract.guidId)) );
                
                contractsOfRemoved.forEach( (c) => {
                    if (this.isContractSelected(c) && !this.isAnyContractSupplySelected(c) && !this.manuallySelectedContractIds.includes(c.guidId)) {
                        this.contractSelectionModel.deselect(c);
                    }
                } )
            }
            
        })

        this.contractsForm.controls.status.valueChanges.pipe(distinctUntilChanged()).subscribe(
            (status: string[] | null) => {
                this.applyStatusFilter(status);
                this.fetchConsumptionPoints();
            }
        );

        //o pipe é utilizado para não efetuar um nº de pedidos tão grande, desta forma só efetua um pedido caso o utilizador deixar de escrever durante 500ms
        this.contractsForm.controls.contractNumber.valueChanges.pipe(distinctUntilChanged(), debounceTime(500)).subscribe(
            (contractNumber: string | null) => {
                let contractNumberFilterIndex = this.contractsListingConfig.filters.findIndex( (filter) => filter.columnIdentifier == 'MVContractNumber' );

                if (contractNumber && contractNumber.length > 0) {
                    if (contractNumberFilterIndex > -1) {
                        this.contractsListingConfig.filters[contractNumberFilterIndex].value = contractNumber;
                    } else {
                        let contractNumberFilter = new MVFilter('MVContractNumber', contractNumber, FilterOptionsType.text, FilterOperator.contains);
                        this.contractsListingConfig.filters.push(contractNumberFilter);
                    }
                } else {
                    if (contractNumberFilterIndex > -1) {
                        this.contractsListingConfig.filters.splice(contractNumberFilterIndex, 1);
                    }
                }

                this.fetchConsumptionPoints();
            }
        );

        this.contractsForm.controls.product.valueChanges.pipe(distinctUntilChanged(), debounceTime(500)).subscribe(
            (product: string[] | null) => {
                let productFilterIndex = this.contractsListingConfig.filters.findIndex( (filter) => filter.columnIdentifier == 'FkSupplierProduct' );

                if (product && product.length > 0) {
                    if (productFilterIndex > -1) {
                        this.contractsListingConfig.filters[productFilterIndex].value = product.join('|');
                    } else {
                        let productFilter = new MVFilter('FkSupplierProduct', product.join('|'), FilterOptionsType.number, FilterOperator.in);
                        this.contractsListingConfig.filters.push(productFilter);
                    }
                } else {
                    if (productFilterIndex > -1) {
                        this.contractsListingConfig.filters.splice(productFilterIndex, 1);
                    }
                }

                this.fetchConsumptionPoints();
            }
        );
    }

    applyStatusFilter(status: string[] | null) {
        let statusFilterIndex = this.contractsListingConfig.filters.findIndex( (filter) => filter.columnIdentifier == 'GuidId' );

        if (status && status.length > 0) {
            if (statusFilterIndex > -1) {
                this.contractsListingConfig.filters[statusFilterIndex].value = status.join('|');
            } else {
                let statusFilter = new MVFilter('GuidId', status.join('|'), FilterOptionsType.text, FilterOperator.in, 'FkContractStatusNavigation');
                this.contractsListingConfig.filters.push(statusFilter);
            }
        } else {
            if (statusFilterIndex > -1) {
                this.contractsListingConfig.filters.splice(statusFilterIndex, 1);
            }
        }
    }

    fetchContracts(): void {
        this._contractsService.getContracts(this.contractsListingConfig, true).subscribe(
            (ct) => {
                this.totalRecords.contracts = ct.totalListCount;
                this.contracts = ct.data;
                this.refreshExpandedContractSupplies();
        })

    }

    toggleDetails(contract: IContract) {
        this.contractExpansionModel.toggle(contract)

        // Supplies are only fetched the first time the contract's details table is opened
        if (this.isContractExpanded(contract) && !this.areContractSuppliesLoaded(contract)) {
            this.fetchContractSupplies(contract.guidId);
        }
    }

    // Loads the contracts list (the supply counts come with each contract). A contract's supplies are only fetched when its details table is opened.
    fetchConsumptionPoints(contractId?: string): void {
        this.contractSelectionModel.clear();
        this.contractSupplySelectionModel.clear();

        if (contractId) {
            this.fetchContractSupplies(contractId);
        } else {
            this._contractsService.getContracts(this.contractsListingConfig, true).subscribe( (sr_contracts: ServerResponse<IContract[]>) => {
                this.contracts = sr_contracts.data;
                this.totalRecords.contracts = this.contracts.length;
                this.refreshExpandedContractSupplies();
            })
        }
    }

    // Gets the electricity, natural gas and self-consumption supplies of a contract, shown in its details table
    fetchContractSupplies(contractId: string): void {
        let contractData = this.contracts.find( (cnt) => cnt.guidId == contractId );

        if (!contractData) {
            return;
        }

        // Spinner inside the contract's details table instead of the full-screen one
        const loaderConfig = new LoaderConfig(true, false, this.getContractSuppliesLoaderName(contractId));

        forkJoin({
            electricity: this._contractsService.getContractElectricitySupplies(contractId, undefined, loaderConfig),
            naturalGas: this._contractsService.getContractNaturalGasSupplies(contractId, undefined, loaderConfig),
            selfConsumption:  this._contractsService.getContractSelfConsumptionSupplies(contractId, undefined, loaderConfig)
        }).subscribe((sr_supplies) => {
            contractData!.electricitySupplies = sr_supplies.electricity.data;
            contractData!.naturalGasSupplies = sr_supplies.naturalGas.data;
            contractData!.selfConsumptionSupplies = sr_supplies.selfConsumption.data;
        })
    }

    // After the list is reloaded, contracts whose details table is still open need their supplies again
    private refreshExpandedContractSupplies() {
        this.contracts
            .filter( (contract) => this.isContractExpanded(contract) )
            .forEach( (contract) => this.fetchContractSupplies(contract.guidId) );
    }

    getContractSuppliesLoaderName(contractId: string) {
        return 'ContractSupplies_' + contractId;
    }

    areContractSuppliesLoaded(contract: IContract) {
        return !!contract.electricitySupplies && !!contract.naturalGasSupplies && !!contract.selfConsumptionSupplies;
    }
    
    // Fills the filter selects and, once all of them are loaded (the default status filter needs the statuses' ids), loads the contracts
    filtersSelectsCreation() {
        forkJoin({
            districts: this._addressService.getDistricts(),
            statuses: this._contractsService.getContractsStatuses()
        }).subscribe( ({ districts, statuses }) => {
            this.districtSelect = districts.data;
            this.setStatusSelect(statuses);

            this.fetchConsumptionPoints();
        });

        // this.statusDataSource$ = new BehaviorSubject<ISMultiSelectDatasource>(
        // {
        //     apiUrl: `${environment.apiUrl}Contracts/${this._userService.userCountryCode}/Statuses`,
        //     columns: [
        //         new ISColumn('id', 'id'),
        //         new ISColumn('description', 'description', new FilterOptions('', FilterOptionsType.text, FilterOperator.in, undefined, 'description'))
        //     ],
        //     filters: [],
        //     pagination: new ISPagination(100, 0),
        //     totalItems: 0,
        //     styleConditions: undefined
        // });

        //Do the same to the products....


        this.productSelect$ = new BehaviorSubject<ISMultiSelectDatasource>(
            new ISMultiSelectDatasource(
                // ===== CHILD (Product)
                [
                    new ISColumn('id', 'Id', undefined, ColumnType.text, undefined, undefined, SortDirection.asc),
                    new ISColumn('name', 'Name')
                ],

                // ===== GROUP (Supplier)
                [
                    new ISColumn('id', 'Id'),
                    new ISColumn('name', 'Name'),
                    new ISColumn('products', 'Products', undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, true)
                ],

                undefined,
                new ISPagination(10, 1),
                0,
                `${environment.apiUrl}Suppliers/${this._userService.userData?.countryCode}/Products/Get`,
                undefined,

                [
                    new ISMultiSelectStyleObject('text-danger', (item: any) => item?.isActive === false),
                    new ISMultiSelectStyleObject('text-success', (item: any) => item?.isActive === true),
                ]
            )
        );
    }

    private setStatusSelect(st: ServerResponse<Status[]>) {
        // translate each status description before using it (a single stream for all of them, instead of one per status)
        this.statusSelect = st.data;
        this._translateService.stream(this.statusSelect.map(s => s.description))
            .pipe(takeUntil(this._destroy$))
            .subscribe((translations: {[key: string]: string}) => {
                this.statusSelect.forEach(s => s.descriptionTranslated = translations[s.description]);
            });

        // Without emitting, so the status subscription doesn't load the contracts before filtersSelectsCreation does
        const defaultStatusIds = this.DEFAULT_STATUS_FILTERS.map((s) => this.statusSelect.find(ss => ss.description == s)?.id?.toString() ?? '' );
        this.contractsForm.controls.status.setValue(defaultStatusIds, { emitEvent: false });
        this.applyStatusFilter(defaultStatusIds);

        this.statusSelectOptions = this.statusSelect.map((status) => {
            return new ISMultiSelectOption(status.id, status.description);
        });
    }

    getContractSupplies(contract: IContract) {
        return [...(contract.electricitySupplies ?? []), ...(contract.naturalGasSupplies ?? []), ...(contract.selfConsumptionSupplies ?? [])]

    }

    toggleContractSelection(contract: IContract) {
        if (!this.isContractSelected(contract)) {
            this.contractSelectionModel.select(contract)
            this.manuallySelectedContractIds.push(contract.guidId)
        } else {
            this.contractSelectionModel.deselect(contract)
            this.manuallySelectedContractIds.splice(this.manuallySelectedContractIds.findIndex(c => contract.guidId == c), 1)
        }
        
    }

    isContractSelected(contract: IContract) {
        return this.contractSelectionModel.isSelected(contract);
    }

    isAnyContractSelected() {
        return this.contractSelectionModel.selected.length > 0;
    }

    isContractIndeterminate() {
        return this.contractsPage.some((c) => this.contractSelectionModel.isSelected(c)) && !this.contractsPage.every((c) => this.contractSelectionModel.isSelected(c));
    }

    isContractExpanded(contract: IContract) {
        return this.contractExpansionModel.isSelected(contract)
    }

    isAllContractsSelected() {
        return this.contractsPage.every((c) => this.contractSelectionModel.isSelected(c));
    }

    masterContractToggle() {
        if (this.isAllContractsSelected()) {
            this.contractSelectionModel.deselect(...this.contractsPage);
        } else {
            this.contractSelectionModel.select(...this.contractsPage);
        }
    }

    toggleContractSupplySelection(contractSupply: IContractElectricitySupply|IContractNaturalGasSupply|IContractSelfConsumptionSupply) {
        this.contractSupplySelectionModel.toggle(contractSupply);
    }

    isContractSupplySelected(contractSupply: IContractElectricitySupply|IContractNaturalGasSupply|IContractSelfConsumptionSupply) {
        return this.contractSupplySelectionModel.isSelected(contractSupply);
    }

    isAnyContractSupplySelected(contract?: IContract) {
        if (contract) {
            return this.getContractSupplies(contract).filter( cs => this.contractSupplySelectionModel.isSelected(cs)).length > 0;
        }
        
        return this.contractSupplySelectionModel.selected.length > 0 
    }

    isContractSupplyIndeterminate(contract: IContract) {
        return this.getContractSupplies(contract).some( cs => this.contractSupplySelectionModel.isSelected(cs)) && !this.getContractSupplies(contract).every( cs => this.contractSupplySelectionModel.isSelected(cs))
    }

    isAllContractSuppliesSelected(contract: IContract) {
        return this.getContractSupplies(contract).every( cs => this.contractSupplySelectionModel.isSelected(cs))
    }

    masterContractSupplyToggle(contract: IContract) {
        if (this.isAllContractSuppliesSelected(contract)) {
            this.contractSupplySelectionModel.deselect(...this.getContractSupplies(contract));
        } else {
            this.contractSupplySelectionModel.select(...this.getContractSupplies(contract));
        }
    }

    getContractSupplyEquipmentCode(contractSupply: IContractElectricitySupply|IContractNaturalGasSupply|IContractSelfConsumptionSupply) {
        if (Object.hasOwn(contractSupply, 'electricityMeterCode')) {
            return (contractSupply as IContractElectricitySupply).electricityMeterCode
        } else {
            return (contractSupply as IContractNaturalGasSupply).naturalGasMeterCode
        }
    }

    getContractSupplyEquipmentCounty(contractSupply: IContractElectricitySupply|IContractNaturalGasSupply|IContractSelfConsumptionSupply) {
        if (Object.hasOwn(contractSupply, 'electricityMeterCode')) {
            return (contractSupply as IContractElectricitySupply).electricityMeterCounty
        } else {
            return (contractSupply as IContractNaturalGasSupply).naturalGasMeterCounty
        }
    }

    removeAllSelections(){
        this.contractSelectionModel.clear();
        this.contractSupplySelectionModel.clear();
    }

    previousPage() {
        if (this.contractsForm.controls.page.value! > 1 ) {
            this.contractsForm.controls.page.setValue(this.contractsForm.controls.page.value! - 1)
        }
    }

    nextContractsPage() {
        if (this.contractsForm.controls.page.value! < this.contractsMaxPage ) {
            this.contractsForm.controls.page.setValue(this.contractsForm.controls.page.value! + 1)
        }
    }

    get contractsMaxPage(): number {
        return Math.ceil(this.contracts.length / this.contractsForm.controls.pageSize.value!) 
    }

    sortContractData(sortColumn: string){
        let isOrderChange = this.contractsListingConfig.ordering?.columnIdentifier == sortColumn;

        if (isOrderChange) {
            switch(this.contractsListingConfig.ordering!.direction) {
                case SortDirection.none: 
                    this.contractsListingConfig.ordering!.direction = SortDirection.desc;
                    break;
                case SortDirection.desc:
                    this.contractsListingConfig.ordering!.direction = SortDirection.asc;
                    break;
                case SortDirection.asc:
                    this.contractsListingConfig.ordering!.direction = SortDirection.none;
                    break;

                default:
                    break;
            }
        } else {
            let translationArray = this.filterTranslationObject[sortColumn];
            let filter = new MVOrdering(translationArray[0], SortDirection.desc, translationArray[1])

            this.contractsListingConfig.ordering = filter;
        }

        this.fetchConsumptionPoints();
    }

    sortContractSupplyData(sortColumn: string, contractId: string){
        let isOrderChange = this.contractSuppliesListingConfig.ordering?.columnIdentifier == sortColumn;

        if (isOrderChange) {
            switch(this.contractSuppliesListingConfig.ordering!.direction) {
                case SortDirection.none: 
                    this.contractSuppliesListingConfig.ordering!.direction = SortDirection.desc;
                    break;
                case SortDirection.desc:
                    this.contractSuppliesListingConfig.ordering!.direction = SortDirection.asc;
                    break;
                case SortDirection.asc:
                    this.contractSuppliesListingConfig.ordering!.direction = SortDirection.none;
                    break;

                default:
                    break;
            }
        } else {
            let translationArray = this.filterTranslationObject[sortColumn];
            let filter = new MVOrdering(translationArray[0], SortDirection.desc, translationArray[1])

            this.contractSuppliesListingConfig.ordering = filter;

        }

        this.fetchConsumptionPoints(contractId);
    }

    getContractColumnSortDirectionClass(columnName: string) {
        if (this.contractsListingConfig.ordering?.columnIdentifier == columnName) {
            switch(this.contractsListingConfig.ordering?.direction) {
                case SortDirection.none:
                    return 'fa-sort';
                case SortDirection.asc:
                    return 'fa-sort-up';
                case SortDirection.desc:
                    return 'fa-sort-down';
                default: 
                    return '';
            }
        }

        return '';
    }

    getContractSupplyColumnSortDirectionClass(columnName: string) {
        if (this.contractSuppliesListingConfig.ordering?.columnIdentifier == columnName) {
            switch(this.contractSuppliesListingConfig.ordering?.direction) {
                case SortDirection.none:
                    return 'fa-sort';
                case SortDirection.asc:
                    return 'fa-sort-up';
                case SortDirection.desc:
                    return 'fa-sort-down';
                default: 
                    return '';
            }
        }

        return '';
    }

    onTableActionClick(event: any) {
        const id = event.guidId;
        if(id){
            this._router.navigate(['/contracts/' + id]);
        }
    }

    goToLink(url: string) {
        window.open(url, "_blank")
    }

    getStatusColor(status: string) {
        return this.contractStatesLabels.find( (statusLabel) => statusLabel.id == status )?.color;
    }

    get contractsPage() {
        let pageStart = this.contractsForm.controls.pageSize.value! * (this.contractsForm.controls.page.value! - 1);
        let pageEnd = pageStart + this.contractsForm.controls.pageSize.value!;

        return this.contracts.slice( pageStart, pageEnd );
    }

    get contractsRange() {
        let total = this.contracts.length;
        let from = Math.min(this.contractsForm.controls.pageSize.value! * (this.contractsForm.controls.page.value! - 1) + 1, total);
        let to = from == 0 ? 0 : from + this.contractsPage.length - 1;

        return { from, to, total };
    }

    onContractAccessRequest(){
        this._dialog.open(ContractAccessComponent, {
            width: '90vw', // 90% of the viewport width
            maxWidth: '640px', // Maximum width for larger screens
            maxHeight: '90vh', // Grow with the content, scroll the body beyond this
            panelClass: 'responsive-dialog', // Optional: Add a custom class for additional styling
        })
        .afterClosed()
        .subscribe((refreshContractAccesses) => {
            if (refreshContractAccesses) {
                this.fetchContracts();
            }
        });
    }

    openTicketPopup(){
        let selectionDataByContract = {
            contracts: this.contractSelectionModel.selected.map(cn => ({ id: cn.guidId, number: cn.contractNumber }) ),
            electricitySupplies: this.contractSupplySelectionModel.selected.filter(supp => Object.hasOwn(supp, 'electricityMeterCode')).map(supp => ({ id: supp.guidId, code: (supp as IContractElectricitySupply).electricityMeterCode }) ),
            naturalGasSupplies: this.contractSupplySelectionModel.selected.filter(supp => Object.hasOwn(supp, 'naturalGasMeterCode')).map(cn => ({ id: cn.guidId, code: (cn as IContractNaturalGasSupply).naturalGasMeterCode }) ),
        }
        
        this._dialog.open(TicketFormComponent, {
            width: '65vw', // 90% of the viewport width
            height: '65vh', // 80% of the viewport height
            panelClass: 'responsive-dialog', // Optional: Add a custom class for additional styling
            data: selectionDataByContract
        })
        .afterClosed()
        .subscribe((refreshContractAccesses) => {
            if (refreshContractAccesses) {
                this.fetchContracts();
            }
        });
    }

    //Show the active filters count
    get activeFilterCount(): number{
        let count = 0;

        if (this.contractsForm?.get('status')?.value?.length) 
            count++;
        if (this.contractsForm?.get('contractNumber')?.value)
            count++;
        if (this.contractsForm?.get('district')?.value?.length)
            count++;
        if(this.contractsForm?.get('product')?.value?.length)
            count++;

        return count;
    }

    
}